import PropTypes from "prop-types"
import React from "react"

import "./SimpleText.scss"
import colors from "../../assets/sass/common/_colors.scss"

import Section from "../../components/section"
import SectionInner from "../../components/section-inner/section-inner"

const SimpleText = ({ title, bgColor, text, textColor }) => {
  return (
    <Section className="SimpleText Section--vPadding" style={{ backgroundColor: bgColor }}>
      <SectionInner className="SimpleText-inner" style={{ color: textColor }}>
        { title &&
          <h2 className="Section-title t-h2">{title}</h2>
        }
        <div className="Section-text t-body2" dangerouslySetInnerHTML={{ __html: text }}/>
      </SectionInner>
    </Section>
  )
}

SimpleText.propTypes = {
  title: PropTypes.string,
  bgColor: PropTypes.string,
  text: PropTypes.string,
  textColor: PropTypes.string,
}

SimpleText.defaultProps = {
  bgColor: colors.colorBgDark,
  textColor: colors.colorDarkPrimary,
}

export default SimpleText
